var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"payment-page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"payment-container"},[_c('div',{ref:("" + _vm.type),attrs:{"id":"dropin-container"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }